import { useCallback, useState } from "react";

import { LAST_ORDER_SELECTED } from "../constants";

export default function useLastSelectedOrderCustomerPortal() {
  const [lastOrderId, _setLastOrderId] = useState<number | undefined>(
    window.localStorage.getItem(LAST_ORDER_SELECTED)
      ? Number(window.localStorage.getItem(LAST_ORDER_SELECTED))
      : undefined
  );

  const setLastOrderId = useCallback((orderId?: number) => {
    if (orderId) {
      window.localStorage.setItem(LAST_ORDER_SELECTED, orderId?.toString());
    } else {
      window.localStorage.removeItem(LAST_ORDER_SELECTED);
    }
    _setLastOrderId(orderId);
  }, []);

  return [lastOrderId, setLastOrderId] as const;
}
